import type {ComponentPropsWithoutRef} from 'react';
import styles from './check-box.module.css';

type Props = ComponentPropsWithoutRef<'label'> & {
  readonly inputProps: ComponentPropsWithoutRef<'input'>;
};

/**
 * スタイルが TestMailButton のレイアウトに強く依存しているので、再利用しないでください
 */
export function TestMailButtonCheckBox({
  inputProps,
  children,
  ...props
}: Props) {
  return (
    <label className={styles.label} {...props}>
      <span className={styles.checkboxContainer}>
        <input className={styles.checkbox} type='checkbox' {...inputProps} />
      </span>

      {children}
    </label>
  );
}
